import React, { FC } from 'react';
import { Heading, ModalMobileLayout, Text } from '@wix/design-system';
import { ConnectCalendarModalLayoutProps } from '../types';

export const ConnectCalendarModalMobileLayout: FC<ConnectCalendarModalLayoutProps> = ({ title, subtitle, onCloseButtonClick, content, footnote }) => (
  <ModalMobileLayout
    title={
      <>
        <Heading size="small">{title}</Heading>
        <Text size="tiny" weight="thin">
          {subtitle}
        </Text>
      </>
    }
    onCloseButtonClick={onCloseButtonClick}
    content={content}
    footer={footnote}
  />
);
